import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Switch } from "@/components/ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { ProfileSelect } from "@/components/ProfileSelect";
import { api, errMsg, CATEGORIES } from "@/lib/api";
import { toast } from "sonner";

const EMPTY = { title: "", due_date: "", category: "Altro", profile_id: null, notes: "", remind_days: 7, recurrence: "none", email_reminder: true, amount: "" };

export const DeadlineDialog = ({ value, onClose, onSaved, profiles }) => {
  const [f, setF] = useState(EMPTY);
  useEffect(() => {
    if (value) setF({ ...EMPTY, ...value, amount: value.amount ?? "" });
  }, [value]);
  const set = (k) => (v) => setF((p) => ({ ...p, [k]: v?.target ? v.target.value : v }));

  const save = async () => {
    const body = { ...f, remind_days: Number(f.remind_days), amount: f.amount === "" ? null : Number(f.amount) };
    try {
      if (value?.deadline_id) await api.put(`/deadlines/${value.deadline_id}`, body);
      else await api.post("/deadlines", body);
      toast.success("Scadenza salvata");
      onSaved();
      onClose();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  return (
    <Dialog open={!!value} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg" data-testid="deadline-dialog">
        <DialogHeader><DialogTitle>{value?.deadline_id ? "Modifica scadenza" : "Nuova scadenza"}</DialogTitle></DialogHeader>
        <div className="grid gap-4">
          <div><Label>Cosa scade</Label><Input value={f.title} onChange={set("title")} placeholder="es. Bollo auto Panda" data-testid="deadline-title-input" /></div>
          <div className="grid grid-cols-2 gap-3">
            <div><Label>Data</Label><Input type="date" value={f.due_date} onChange={set("due_date")} data-testid="deadline-date-input" /></div>
            <div><Label>Importo (€)</Label><Input type="number" step="0.01" value={f.amount} onChange={set("amount")} data-testid="deadline-amount-input" /></div>
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div><Label>Categoria</Label>
              <Select value={f.category} onValueChange={set("category")}>
                <SelectTrigger data-testid="deadline-category-select"><SelectValue /></SelectTrigger>
                <SelectContent>{CATEGORIES.map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}</SelectContent>
              </Select>
            </div>
            <div><Label>Per chi</Label><ProfileSelect value={f.profile_id || "me"} onChange={(v) => set("profile_id")(v === "me" ? null : v)} profiles={profiles} testId="deadline-profile-select" /></div>
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div><Label>Avvisami (giorni prima)</Label><Input type="number" min="0" max="90" value={f.remind_days} onChange={set("remind_days")} data-testid="deadline-remind-input" /></div>
            <div><Label>Ripetizione</Label>
              <Select value={f.recurrence} onValueChange={set("recurrence")}>
                <SelectTrigger data-testid="deadline-recurrence-select"><SelectValue /></SelectTrigger>
                <SelectContent><SelectItem value="none">Nessuna</SelectItem><SelectItem value="monthly">Ogni mese</SelectItem><SelectItem value="yearly">Ogni anno</SelectItem></SelectContent>
              </Select>
            </div>
          </div>
          <div><Label>Note</Label><Textarea value={f.notes || ""} onChange={set("notes")} rows={2} data-testid="deadline-notes-input" /></div>
          <label className="flex items-center justify-between text-sm">Promemoria anche via email<Switch checked={f.email_reminder} onCheckedChange={set("email_reminder")} data-testid="deadline-email-switch" /></label>
        </div>
        <DialogFooter>
          <Button variant="ghost" onClick={onClose} data-testid="deadline-cancel-btn">Annulla</Button>
          <Button onClick={save} disabled={!f.title || !f.due_date} data-testid="deadline-save-btn">Salva</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
